// extracted by mini-css-extract-plugin
export default {"scoreBar":"RKP_IUejreeTDzr6dBJi","svgContainer":"PlI_oRq9v5yCIBOeXB3y","blank":"JpPtX5FRWHogvKSy5rdZ","fill":"nXXU241VJWqYOMVYpnXC","halfScoreFilling":"KJ6FtRiF2qHc6TLJDGFM"};